module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Tablet-d73ccf1594152c7c5083ff162ad8f35d.svg";